export const Logo = ({ light = false, compact = false }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="brand-logo">
    <svg width="38" height="38" viewBox="0 0 40 40" aria-hidden="true">
      <rect width="40" height="40" rx="10" fill="#FFB703" />
      <path d="M9 30 L9 10 L14 10 L26 24 L26 10 L31 10 L31 30 L26 30 L14 16 L14 30 Z" fill="#0A192F" />
      <path d="M6 34 H34" stroke="#0A192F" strokeWidth="2" strokeDasharray="5 3" />
    </svg>
    {!compact && (
      <span className="leading-none">
        <span className={`block text-[17px] font-extrabold tracking-[0.12em] ${light ? "text-white" : "text-[#0A192F]"}`}>
          NAMMAA<span className="text-[#FFB703]">FLEET</span>
        </span>
        <span className={`font-kn block text-[11px] mt-1 ${light ? "text-slate-300" : "text-slate-500"}`}>ನಮ್ಮ ಫ್ಲೀಟ್</span>
      </span>
    )}
  </span>
);

const TONES = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50 text-amber-800 border-amber-200",
  red: "bg-red-50 text-red-700 border-red-200",
  blue: "bg-sky-50 text-sky-800 border-sky-200",
  gray: "bg-slate-100 text-slate-700 border-slate-200",
};
const MAP = {
  green: ["Completed", "Paid", "approved", "active", "issued", "sent", "Verified", "Configured", "verified", "authenticated", "fixed", "Assigned", "Confirmed"],
  amber: ["Pending Admin Assignment", "Awaiting Driver Assignment", "Partially Paid", "submitted", "pending_review", "queued", "Refund Pending", "estimated", "corrections_requested", "pending", "created", "Sandbox/Test Mode", "confirmation_required", "Requires Attention", "processing", "Partially Refunded"],
  red: ["Cancelled", "Unpaid", "rejected", "failed", "Failed", "halted", "suspended", "Not Configured", "unavailable"],
  blue: ["Driver En Route", "Trip Started", "draft", "Refunded"],
};
export const StatusBadge = ({ value, testid }) => {
  const tone = Object.keys(MAP).find((k) => MAP[k].includes(value)) || "gray";
  return (
    <span data-testid={testid || "status-badge"} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${TONES[tone]}`}>
      {String(value ?? "—").replaceAll("_", " ")}
    </span>
  );
};
